import { render, staticRenderFns } from "./HumanLogs.vue?vue&type=template&id=379c071c&scoped=true&"
import script from "./HumanLogs.vue?vue&type=script&lang=ts&"
export * from "./HumanLogs.vue?vue&type=script&lang=ts&"
import style0 from "./HumanLogs.vue?vue&type=style&index=0&id=379c071c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379c071c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('379c071c')) {
      api.createRecord('379c071c', component.options)
    } else {
      api.reload('379c071c', component.options)
    }
    module.hot.accept("./HumanLogs.vue?vue&type=template&id=379c071c&scoped=true&", function () {
      api.rerender('379c071c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/History/HumanLogs.vue"
export default component.exports